/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef } from 'react';
import { Button, Form, Row, Col, Dropdown, FormControl } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { categorynewlist, saleitemReport, salelist, roomslist, reportsLocationList } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';
import toast from 'shared/toast';
import AREA from 'features/constants/Area';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './SaleItem.scss';
import { NoData } from 'features/components/redirect/NoData';
/**
 * this page is used to show sale item report in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="custom-drop-down-report"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));

export default class SaleItem extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            saletitle: { field: "saletitle", value: "", op: "=", join: "AND" },
            saleid: { field: "saleid", value: "", op: "=", join: "AND" },
            sku: { field: "sku", value: "", op: "LIKE", join: "AND" },
            category: { field: "category", value: "", op: "=", join: "AND" },
            area: { field: "area", value: "", op: "=", join: "AND" },
            invoicenumber: { field: "invoicenumber", value: "", op: "LIKE", join: "AND" },
            // shippable: { field: "shipping", value: "", op: "LIKE", join: "AND" },
            invoicestatus: { field: "invoicestatus", value: "", op: "=", join: "AND" },
            itemtype: { field: "itemtype", value: "", op: "=", join: "AND" },
            starttime: { field: 'fromdate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
            categoryGroup : { field: 'categoryGroup', value: '', op: '=', join: 'AND' },
            isDeleted: { field: 'isDeleted', value: 1, op: '!=', join: 'AND' }
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            category: [],
            sales: [],
            issearch: false,
            saleid: { value: '', valid: false, error: '' },
            locationid: { value: '', valid: false, error: '' },
            searchInput: null,
            showSearchBox: false,
            // saleid: { value: '', valid: false, error: '' },
            locations: [],
            isdisabled: false,
            location: '',
            locationlength: 0,
            Selected_salename: '',
            categoryMenuName: '',
            errorpageredirect: false,
            errorType: '',
            errorMessage:''
        }
        

        this.config = {
            name: 'sale history report',
            url: saleitemReport,
            isReport: true,
            params: {},
            columns: [

                { name: 'Item Name', property: 'itemtitle', sort: false, width: '200px', columnType: 'custom', customColumn: (row) => { if ('itemtitle' in row) return (row.itemtitle) } },
                { name: 'Type', property: 'itemtype', sort: false, width: '200px' },
                { name: 'SKU', property: 'sku', sort: false, width: '200px' },
                { name: 'Category Name', property: 'category', sort: false, width: '200px' },
                { name: 'Invoice Number', property: 'invoicenumber', sort: false, width: '200px' },
                { name: 'Invoice Status', property: 'invoicestatus', sort: false, width: '200px',columnType: 'custom',  customColumn: (data) => this.getinvoicestatus(data) },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: "CSV", width: '200px',
                    actionEvents: {}, accordion: this.accordionValue
                }
            ],
            // sort: [],
            pagination: true,
            field: ["itemtitle", "itemtype", "sku", "category", "invoicenumber", "invoicestatus",  "addoninvoicenumber", "addoninvoicestatus", "invoiceitemreceiptmethod", "itemid", "firstname", "lastname", "nickname", "email", "mobilenumber", "city", "state", "country", "zipcode", "buyerspremium", "taxonbpamount", "itemstatus", "saletitle", "starttime", "endtime", "closetime", "reserveprice", "viewcount", "saleprice", "itemtax", "bidcount", "taxexempt", "saleid", "itemviewurl", "isshippable", "istaxable","bidderacceptance","addonbidderacceptance"],
            filename: "sale-history-report",
            defaultFilter: [{ field: 'salestatus', value: 'Closed', op: '=', join: 'AND' }],
            csvColumn: [
                // { name: 'Category Name', property: 'category', },
                // { name: 'Invoice Status', property: 'invoicestatus', },
                { name: 'Add On Invoice Number', property: 'addoninvoicenumber', },
                { name: 'Add On Invoice Status', property: 'addoninvoicestatus',columnType: 'custom',  customColumn: (data) => this.getaddoninvoicestatus(data)},
                { name: 'Item Receipt Method', property: 'invoiceitemreceiptmethod', },
                { name: 'Item ID', property: 'itemid', },
                { name: 'Winner First Name', property: 'firstname', },
                { name: 'Winner Last Name', property: 'lastname', },
                { name: 'Winner Username', property: 'nickname', },
                { name: 'Winner Email', property: 'email', },
                { name: 'Phone', property: 'mobilenumber', },
                { name: 'Profile Address', columnType: 'custom', customColumn: this.customAddress },
                // { name: 'Winner Address2', property: 'address2', },
                { name: 'Winner City', property: 'city', },
                { name: 'State / Province', property: 'state', },
                { name: 'Winner Country', property: 'country', },
                { name: 'Zip / Postal Code', property: 'zipcode', },
                { name: 'Buyers Premium', property: 'buyerspremium', columnType: 'custom', customColumn: this.checkBP },
                { name: 'Tax Buyers Premium', property: 'taxonbpamount', columnType: 'custom', customColumn: (row) => { if ('taxexempt' in row && row.taxexempt.toLowerCase() === 'yes' || row.istaxable == 0) { return 0 } else { if ('taxonbpamount' in row && row.taxonbpamount !== null) { return (`${row.taxonbpamount}`) } else { return 0 } } } },
                { name: 'Status', property: 'itemstatus', },
                { name: 'Sale Title', property: 'saletitle', columnType: 'custom', customColumn: (row) => { if ('saletitle' in row) return (row.saletitle) } },
                { name: 'Sale Start Date', property: 'starttime', columnType: 'custom', customColumn: this.customStartTime },
                { name: 'Sale End Date', property: 'endtime', columnType: 'custom', customColumn: this.customEndTime },
                { name: 'Item Close Time', property: 'closetime', columnType: 'custom', customColumn: this.customCloseTime },
                { name: 'Reserve Price', property: 'reserveprice', columnType: 'custom', customColumn: (row) => { if ('reserveprice' in row && row.reserveprice !== null) { return (`${parseFloat(row.reserveprice).toFixed(2)}`) } else { return 0 } } },
                { name: 'Number of Views', property: 'viewcount', },
                { name: 'Sale Price', property: 'saleprice', columnType: 'custom', customColumn: (row) => { if ('saleprice' in row && row.saleprice !== null) { return (`${parseFloat(row.saleprice).toFixed(2)}`) } else { return 0 } } },
                { name: 'Tax', property: 'itemtax', columnType: 'custom', customColumn: (row) => { if ('taxexempt' in row && row.taxexempt.toLowerCase() === 'yes' || row.istaxable == 0) { return 0 } else { if ('itemtax' in row && row.itemtax !== null) { return (`${row.itemtax}`) } else { return 0 } } } },
                { name: 'Number of Bids', property: 'bidcount', },
                { name: 'Taxexempt', property: 'taxexempt', columnType: 'custom', customColumn: (row) => { if ('taxexempt' in row && row.taxexempt !== null) { return row.taxexempt } } },
                { name: 'Sale id', property: 'saleid' },
                { name: 'Item Link', property: 'itemviewurl', },
                { name: 'Item Shippable', property: 'isshippable', columnType: 'custom', customColumn: (row) => { if ('isshippable' in row && row.isshippable == '1') { return 'Yes' } else { return 'No' } } },
            ]

        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.filterSearch = {};
        this.payments = [{ name: "Paid" }, { name: "UnPaid" }]
        this.sales = [];
        this.areas = [];
        this.locations = [];

    }

    componentDidMount = () => {
        this.getCategoryList();
        this.getSaleList();
        // this.getRoomsList();
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    getaddoninvoicestatus(data) {
        if(typeof data["addoninvoicestatus"] == 'string' && (data["addoninvoicestatus"]).toLowerCase() == "paid"){
            return "Paid"
        }
        else if (typeof data["addoninvoicestatus"] == 'string' && (data["addoninvoicestatus"]).toLowerCase() == "unpaid") {
            if (data['addonbidderacceptance'] == "Accepted") {
                return data["addoninvoicestatus"];
            }   
            else {
                return data["addonbidderacceptance"];
            }
        }
    }

    getinvoicestatus(data) {
        if (data["createdtype"] == "System" || data["createdtype"] ==  null) {
            return data["invoicestatus"];
        }
        else if(data["createdtype"] == "Manual" ){
            if(typeof data["invoicestatus"] == 'string'  && (data["invoicestatus"]).toLowerCase() == "paid"){
                return "Paid"
            }
            else if (typeof data["invoicestatus"] == 'string' && (data["invoicestatus"]).toLowerCase() == "unpaid") {
                if (data['bidderacceptance'] == "Accepted") {
                    return data["invoicestatus"];
                }   
                else {
                    return data["bidderacceptance"];
                }
            }
        }
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }


    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto my-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );

    checkBP = (value) => {
        const res = value.buyerspremium ? `${value.buyerspremium}` : "0";
        return res;
    }
    customAddress = (values) => {
        if (values.address2) {
            const res = values.address1 + ' ,' + values.address2;
            return res;
        }
        else {
            const res = values.address1;
            return res;
        }
    }
    customItemUrl = (values) => {
        let itemurl = values["itemviewurl"];
        let hyperlink = "=HYPERLINK(\"" + itemurl + "\"\")";
        return hyperlink;
    }
    /* Get room list */
    getRoomsList = () => {
        axios.get(getSellerUrl(roomslist), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.areas = Object.keys(response.data.data)
                }
            })
            .catch(error => {
            });
    }

    // customAddQuotes = (values) => {
    //     return values.replace(/"/g, '""')
    // }

    customStartTime = (values) => {
        if (values['starttime'] != null) {
            let date = moment(values['starttime']);
            return `${date.format('MM/DD/YYYY hh:mm A')} ${moment.tz(values['timezone']).zoneAbbr()}`;
            // return `${moment(values['starttime']).format('MM/DD/YYYY hh:mm A')}`;
        }
        else
            return '- - -';
    }
    customEndTime = (values) => {
        if (values['endtime'] != null) {
            let date = moment(values['endtime']);
            return `${date.format('MM/DD/YYYY hh:mm A')} ${moment.tz(values['timezone']).zoneAbbr()}`;

            // return `${moment(values['endtime']).format('MM/DD/YYYY hh:mm A')}`;
        }
        else
            return '- - -';
    }
    customCloseTime = (values) => {
        if (values['closetime'] != null) {
            let newdate = moment.tz(values['closetime'], values['closetime']).local();
            return `${newdate.format('MM/DD/YYYY hh:mm:ss A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        else
            return '- - -';
    }


    // properly convert to boolean (Standard method)
    getBool(val) {
        try {
            if (val)
                return !!JSON.parse(String(val).toLowerCase());
            else
                return false
        } catch (e) {
            return false
        }
    }

    dateFormat = (date) => {
        if (date) {
            let newdate = moment.tz(date, date).local();
            return `${newdate.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    }
    /* Get category list */
    getCategoryList = () => {
        axios.get(getSellerUrl(categorynewlist), getSellerHeaders(false))
            .then(response => {
                if (response.status === 200) {
                    let category = response.data.data.data[0]
                    Object.values(category).map((item) => {
                        return item.sort()
                    })
                    this.setState({
                        ...this.state,
                        category,
                    });
                }
            })
            .catch(error => {
                // toast.error(error?.response?.data['message']);
            });
    }
    /* Get sales list */
    getSaleList = (locationChange = false) => {
        let filter = []
        if (!this.state.search.locationid.value) {
            filter = [
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        } else {
            filter = [
                { field: 'locationid', value: this.state.search.locationid.value, op: '=', join: 'AND' },
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }
        if(locationChange){
            this.setState({
                ...this.state,
                search: {
                    ...this.state.search,
                    saleid: {
                        ...this.state.search.saleid,
                        value: '',
                    }
                }
            });

        }
       
        let field = ["title", "id"]
        var data = {
            "field": field,
            "filter": filter
        };
        axios.post(getSellerUrl(salelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.sales = response.data.data;
                    const temp = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        ...this.state,
                        sales: temp,
                    });
                }
            })
            .catch(error => {
            });
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        let categoryName = '';
        if (typeof event?.target?.selectedIndex === 'number' && event.target.selectedIndex > -1) {
            categoryName = event.target.options[event.target.selectedIndex]?.parentNode?.label;
        }
        if (event.target.name === 'saleid') {
            eventValue = Number(eventValue)
            setTimeout(() => {
                this.setState({
                    ...this.state,
                    errorMessage: '',
                    search: {
                        ...this.state.search,
                        starttime: {
                            ...this.state.search.starttime,
                            value:''
                        },
                        endtime: {
                            ...this.state.search.endtime,
                            value:''
                        }
                    }
                })
            }, 10);
        }
        if (event.target.name === 'locationid') {
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                Selected_salename: "",
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: Number(eventValue)
                    }
                }
            }, () => {
                this.getSaleList(true);
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
        else if (event.target.name === "category") {
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    },
                    categoryGroup: {
                        ...this.state.search.categoryGroup,
                        value: typeof categoryName === "string" ? categoryName : ''
                    }
                }
            }, () => {
                if (event.target.value === '') {
                    this.checkSearch();
                }
            });
        } 
        else {
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }


    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            Selected_salename: ""
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        const {search, errorMessage} = this.state
        if (e.key === 'Enter' && !errorMessage && (search.saleid.value || (search.starttime.value && search.endtime.value)) ) {
            if(search.locationid.value ){
                this.enableSearch()
            }
        }
    }

    /* called when search button clicked */
    enableSearch = () => {
        let startDate = null
        let endDate = null

        if (this.state.search.starttime.value) {
            let startDateFormat = moment(this.state.search.starttime.value).format("YYYY-MM-DD")
            startDate = moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        }

        if (this.state.search.endtime.value) {
            let endDateformat = moment(this.state.search.endtime.value).format("YYYY-MM-DD")
            endDate = moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        }
        var search = {
            // saletitle: { ...this.state.search.saletitle, },
            saleid: { ...this.state.search.saleid, value: this.state.search.saleid.value },
            sku: { ...this.state.search.sku, value: this.state.search.sku.value !== "" && `%${this.state.search.sku.value}%` },
            category: { ...this.state.search.category },
            area: { ...this.state.search.area, },
            invoicenumber: { ...this.state.search.invoicenumber, value: this.state.search.invoicenumber.value !== "" && `%${this.state.search.invoicenumber.value}%` },
            // shippable: { ...this.state.search.shippable, value: this.state.search.shippable.value !== "" && `%${this.state.search.shippable.value}%` },
            invoicestatus: { ...this.state.search.invoicestatus },
            itemtype: { ...this.state.search.itemtype },
            starttime: { ...this.state.search.starttime, value: startDate || ''},
            endtime: { ...this.state.search.endtime, value: endDate || '' },
            locationid: { ...this.state.search.locationid, },
            categorygroup: { ...this.state.search.categoryGroup },
            isDeleted: { field: 'isDeleted', value: 1, op: '!=', join: 'AND' }
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    serachValueCheck = () =>{
        if(this.state.search.saleid.value){
            return false
        }
        else if(this.state.search.endtime.value && this.state.search.starttime.value){
            return false
        }
        else{
            return true
        }
          
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }
    getTimeZone = () => {
        const timeZone = momentTz.tz.guess();
        return momentTz.tz(timeZone).zoneAbbr();
    }
    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr);
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div className="accordion-view" style={{ padding: "1% 1%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex">
                        <div>
                            {"area" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Area</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["area"]}</div>
                            </div>}
                            {"invoicenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Invoice</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["invoicenumber"] != null ? "Created" : "Not Created"}</div>
                            </div>}
                            {"bidcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Bids</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["bidcount"]}</div>
                            </div>}
                            {"viewcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Views</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["viewcount"]}</div>
                            </div>}
                            {"soldamount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sold Amount $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">:{row["soldamount"]}</div>
                            </div>}
                            {"tax" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Tax $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["tax"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"goal" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Goal $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["goal"]}</div>
                            </div>}
                            {"value" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Value $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["value"]}</div>
                            </div>}
                            {"handling" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Handling $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["handling"]}</div>
                            </div>}
                            {"shipping" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Shipping $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["shipping"]}</div>
                            </div>}
                            {"buyerspremium" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyers Premium $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["buyerspremium"]}</div>
                            </div>}
                            {/* Highest Proxy Bid field for admin app */}
                            {"highestproxyamount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Highest Proxy Bid $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["highestproxyamount"]}</div>
                            </div>}
                            {/* Final Sale Price for seller app */}
                            {/* {"saleprice" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Final Sale Price $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["saleprice"]}</div>
                            </div>} */}
                        </div>
                        <div style={{ marginLeft: "-27px", paddingRight: "60px" }}>
                            {"directbuy" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Direct Buy $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["directbuy"]}</div>
                            </div>}
                            {"starttime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sale Start Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['starttime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()}</div>
                                {/* <div className="accordion-row-text">{tr !== "" && moment(row['starttime']).format('MM/DD/YYYY hh:mm A')} </div> */}
                            </div>}
                            {"endtime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sale End Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['endtime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()} </div>
                            </div>}
                            {"firstname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer First Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["firstname"]}</div>
                            </div>}
                            {"lastname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Last Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["lastname"]}</div>
                            </div>}
                            {"nickname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer User Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["nickname"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"email" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Email</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["email"]}</div>
                            </div>}
                            {"mobilenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Phone</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["mobilenumber"]}</div>
                            </div>}
                            {"address1" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Address</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["address1"]}</div>
                            </div>}
                        </div>

                    </div>
                    : ''}
            </div>
        );
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        const { search } = this.state;
        let errorMessage = '';
    
        // always update in state
        const updatedSearch = {
            ...search,
            [control]: {
                ...search[control],
                value: date
            }
        };
    
        // validate only when both dates exist
        if (updatedSearch.starttime.value && updatedSearch.endtime.value) {
            const start = new Date(updatedSearch.starttime.value);
            const end = new Date(updatedSearch.endtime.value);
    
            const monthsDiff =
                (end.getFullYear() - start.getFullYear()) * 12 +
                (end.getMonth() - start.getMonth());

            if (end < start) {
                errorMessage = "Please select a date range within any 12 month period";
                updatedSearch.endtime.value = null;
            }
            else if (monthsDiff > 12 || (monthsDiff === 12 && end.getDate() > start.getDate())) {
                errorMessage = "Please select a date range within any 12 month period";
            }
        }
    
        this.setState({
            issearch: true,
            errorMessage,
            search: updatedSearch
        });

    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            this.setState({
                showSearchBox: event,
                sales: [],
                searchInput: null,
            });
        }, event ? 500 : 100);
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            this.getSaleList();
        });
    }

    saleSelect = (sale) => {
        if (this.state.search.saletitle.value !== sale.title) {
            this.setState({
                searchInput: null,
                sales: [],
                Selected_salename: sale.title
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.searchInputChange(event);
            });
        }
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(reportsLocationList, '' , true), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    }, () => {
                        this.getSaleList();
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                    })
                }
            })
            .catch(error => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }} id="sale-hostory-report">
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Please select location</option>
                                            {/* {this.state.locations.length > 1 ? <option value="All">All</option> : ''} */}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale Title</label>
                                        {/* <Form.Control as="select" onKeyDown={this._handleKeyDown} name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => {this.searchInputChange(event) }}>
                                            <option value="" >Select Sale</option>
                                            {this.state.sales.map((sale, index) =>
                                                <option key={index} value={sale.id}>{sale.title}</option>
                                            )}
                                        </Form.Control> */}
                                        <Dropdown onToggle={(event) => this.toggleSearchBox(event)}>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                {this.state.Selected_salename ? this.state.Selected_salename : "Select Sale"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu as={this.CustomMenu} className="custom-dropdown-menu" >

                                                {this.state.sales.map((sale, index) => {
                                                    return (
                                                        <Dropdown.Item key={sale.id} eventKey={sale.title} onClick={() => this.saleSelect(sale)} active={this.state.search.saletitle.value === sale.title}>
                                                            {sale.title}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                    <Col>
                                        <label>Category</label>
                                        <Form.Control as="select" name="category"  onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value=''>All</option>
                                            {Object.keys(this.state.category).sort().map((category, index) =>
                                                <optgroup key={index} label={category} style={{ backgroundColor: "#efefef" }}>
                                                    {
                                                        this.state.category[category].length > 0 ?
                                                            this.state.category[category].map((subcategory, subIndex) =>
                                                                <option key={index + subIndex} value={subcategory} style={{ backgroundColor: "white" }}  selected={
                                                                    this.state.search.categoryGroup.value === category &&
                                                                    this.state.search.category.value === subcategory
                                                                  } >{subcategory}</option>
                                                            ) :
                                                            <option key={index + 'no' + index} disabled style={{ backgroundColor: "white" }}>- - - - -</option>
                                                    }
                                                </optgroup>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date From {!this.state.search.saleid.value && '*'}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker  disabled={this.state.search.saleid.value} ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>

                                    {/* <Col>
                                        <label>Item Type</label>
                                        <Form.Control as="select" name="itemtype" value={this.state.search.itemtype.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' >All</option>
                                            <option value="Auction">Auction</option>
                                            <option value="Direct Buy">Direct Buy</option>
                                            <option value="Onsite">Onsite</option>
                                        </Form.Control>
                                    </Col> */}
                                </Row>
                                <Row>
                                    <Col>
                                        <label>Sale End Date To {!this.state.search.saleid.value && '*'}</label>
                                        <div>
                                            <label disabled={this.state.search.saleid.value} style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker   disabled={this.state.search.saleid.value}  minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Item Type</label>
                                        <Form.Control as="select" name="itemtype" value={this.state.search.itemtype.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' >All</option>
                                            <option value="Auction">Auction</option>
                                            <option value="Direct Buy">Direct Buy</option>
                                            <option value="Onsite">Onsite</option>
                                        </Form.Control>
                                    </Col>
                                    {/* <Col>
                                        <label>Area</label>
                                        <Form.Control as="select" name="area" value={this.state.search.area.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' >All</option>
                                            {AREA.map((type, index) =>
                                                <option key={index} value={type}>{type}</option>
                                            )}
                                        </Form.Control>
                                    </Col> */}
                                    {/* <Col>
                                        <label>Shipping</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="shippable" value={this.state.search.shippable.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col> */}
                                    <Col>
                                        <label>Payment</label>
                                        <Form.Control as="select" name="invoicestatus" value={this.state.search.invoicestatus.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value='' >All</option>
                                            {this.payments.map((type, index) =>
                                                <option key={index} value={type.name}>{type.name}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col></Col>
                                </Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>

                                    <Col></Col>
                                    <Col className="d-flex justify-content-center align-items-center">
                                        {this.state.errorMessage && (
                                            <div className="text-danger"  style={{fontSize: '14px'}}>
                                                {this.state.errorMessage}
                                            </div>
                                        )}
                                    </Col>
                                    <Col>
                                        <div className="buttonClass">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={(this.state.locationlength > '1' ? !this.state.isdisabled : !this.state.isdisabled) || this.state.errorMessage  || this.serachValueCheck()} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}